import { useOrganization } from '../Hooks/useOrganization';
import orgLogo from '../assets/projects/default-icons/Org-Logo.svg';

export default function useOrgLogo(): string {
  const [, org] = useOrganization();
  return org?.logo ? org.logo : orgLogo;
}
